import { Modal } from "antd";
import ModalPeu from "./ModalPeu";
import ModalPostagem from "./ModalPostagem";
import ModalInt from "./ModalInt";

export default function ModalMaisInfo({
  isModalOpen,
  handleFechar,
  compatibilidadeId,
  compatibilidadeOrigem,
}: any) {
  const renderModal = () => {
    if (!compatibilidadeId || !compatibilidadeOrigem) {
      return <p>{"Carregando informa\u00e7\u00f5es..."}</p>;
    }

    switch (compatibilidadeOrigem) {
      case "PEU":
        return <ModalPeu id={compatibilidadeId} isOpen={isModalOpen} />;
      case "INT":
        return <ModalInt id={compatibilidadeId} isOpen={isModalOpen} />;
      case "POST":
      default:
        return <ModalPostagem id={compatibilidadeId} isOpen={isModalOpen} />;
    }
  };

  return (
    <Modal open={isModalOpen} onCancel={handleFechar} footer={null}>
      {renderModal()}
    </Modal>
  );
}
